import React, { useEffect, useRef, useState } from 'react';
import { FiSave } from 'react-icons/fi';

import Header from '../../components/header';

import api from '../../services/api';

function EditSuggestion({ history, match, location }) {
    const detailsInput = useRef(null);
    const [details, setDetails] = useState([]);

    const { app } = location.state || {
        app: {
            _id: match.params.appId,
        },
    };
    const { suggestion } = location.state || {};

    useEffect(() => {
        if (suggestion && suggestion.details) {
            setDetails(suggestion.details);
        }
    }, []);

    if (!suggestion) {
        history.push({
            pathname: `/apps/${app._id}/suggestions`,
            state: { app },
        });

        return null;
    }

    async function editSuggestion() {
        const newDetail = detailsInput.current.value;
        if (newDetail.length > 0) {
            const newDetails = [ ...details, newDetail ];
            await api.put(`/v0/suggestions/${suggestion._id}`, { details: newDetails });
            detailsInput.current.value = '';
            setDetails(newDetails);
        }
    }

    return (
        <>
            <Header
                left={{
                    pathname: `/apps/${app._id}/suggestions`,
                    state: { app },
                }}
                right={<button className="icon-link" onClick={editSuggestion}><FiSave /></button>}
            />
            <main className="main-content">
                <h2>Sugestão - {app.name}</h2>
                <div className="item-content">
                    <h3>{suggestion && suggestion.title}</h3>
                    {details.map((detail, index) => (
                        <pre key={index}>{detail}</pre>
                    ))}
                </div>
                <div className="input-group">
                    <textarea placeholder="Novo detalhe" ref={detailsInput}></textarea>
                </div>
            </main>
        </>
    );
}

export default EditSuggestion;